import React from 'react';

import styled from '@emotion/styled';

import { Modal } from '../../components/Modal/Modal';
import { TableComponent } from '../../components/TableCom';
import { ModalProvider } from '../../context/ModalContext';
import { TableRefreshProvider } from '../../context/TableRefreshContext';
import CreateDispatcher from '../../sections/dashboard/users/CreateDispatcher';
import CreateDispatcherModal from '../../sections/dashboard/users/CreateDispatcherModal';

const DispatcherUser = () => {
  return (
    <TableRefreshProvider>
      <ModalProvider>
        <Container>
          <CreateDispatcher />
          <TableComponent
            tableBaseUrl="authentication-service/v1/dispatchers"
            tableHeader={[
              'firstName',
              'lastName',
              'email',
              'phoneNumber',
              'vehicleType',
              'verified',
            ]}
            mappingData={{
              firstName: 'First Name',
              lastName: 'Last Name',
              email: 'Email',
              phoneNumber: 'Phone Number',
              vehicleType: 'Vehicle Type',
              verified: 'Verified',
            }}
          />
        </Container>
        <Modal>
          <CreateDispatcherModal />
        </Modal>
      </ModalProvider>
    </TableRefreshProvider>
  );
};

export default DispatcherUser;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
